<template>
  <div></div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { inboxNotificationSound } from "@/src/constants/inboundAgent.js";
import { getCurrentEnvironment } from "@/src/constants/environmentConstants.js";
import eventBus from "@/src/utils/eventBus.js";
import mqttService from "@/src/services/mqtt/mqttService.js";
import WorkspaceService from "@/src/api/WorkspaceService.js";

const handleInboxNewNotification = async (id) => {
  try {
    if (id?.toString() === localStorage.getItem("userId")) {
      const audio = new Audio(inboxNotificationSound);
      await audio.play();
    }
  } catch (error) {
    console.error("An error occurred while inbox new notification: ", error);
  }
};

const handleMQTTMessage = (message, topic) => {
  try {
    eventBus.emit("inbox-refresh-conversations");

    if (message.entity_type === "user" && message.agent_id) {
      eventBus.emit("inbox-message-notification", message.agent_id);
    }

    if (message.conversation_id) {
      eventBus.emit("inbox-message-received", message);
    }
  } catch (error) {
    console.error("Error handling MQTT message:", error);
  }
};

const subscribeToLivechatTopics = async () => {
  try {
    const workspaceId = WorkspaceService.getCurrentWorkspaceId();
    if (!workspaceId) return;

    const topic = `${getCurrentEnvironment()}/livechat/${workspaceId}/+`;
    await mqttService.subscribe(topic, handleMQTTMessage);
  } catch (error) {
    console.error("Failed to subscribe to livechat topics:", error);
  }
};

const unsubscribeFromLivechatTopics = async () => {
  try {
    const workspaceId = WorkspaceService.getCurrentWorkspaceId();
    if (workspaceId) {
      const topic = `${getCurrentEnvironment()}/livechat/${workspaceId}/+`;
      await mqttService.unsubscribe(topic);
    }
  } catch (error) {
    console.error("Failed to unsubscribe from livechat topics:", error);
  }
};

onMounted(async () => {
  const handleMQTTReady = async () => {
    await subscribeToLivechatTopics();
  };

  eventBus.on("mqtt-connected", handleMQTTReady);

  if (mqttService.isConnected) {
    await subscribeToLivechatTopics();
  }

  eventBus.on("inbox-message-notification", (id) =>
    handleInboxNewNotification(id),
  );
});

onUnmounted(async () => {
  await unsubscribeFromLivechatTopics();

  eventBus.off("mqtt-connected");
  eventBus.off("inbox-message-notification", (id) =>
    handleInboxNewNotification(id),
  );
});
</script>
